import script from "./EditAnnouncement.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAnnouncement.vue?vue&type=script&setup=true&lang=js"

import "./edit-announcement.scss?vue&type=style&index=0&lang=scss"

export default script